import styled from 'styled-components';
import { media } from '../styledMedia';
import { Card } from '@mui/material';

//Material-Ui Card component with responsive design
export default styled(Card)`
  && {
    ${media.xs`
      box-shadow:none;
  `}
  }
`;
